<template>
  <div>
    <div>
      <p><b>עיר עבודה (3)</b></p>
      <input @input="searchCity($event.target.value)" v-model="search_term" class="outlined" placeholder="אנא הקלד/י עיר מגורים...">
    </div>
    <div class="search_results">
      <p @click="chooseCity(result)" v-for="result in search_results" :key="result.id" class="search_result m-0">{{ result.name }}</p>
    </div>
    <div>
      <div v-for="picked_city in picked_cities" :key="picked_city.id"
           class="is-flex is-align-items-center is-justify-content-space-between faded_border_bottom" style="width: 310px; margin-top: 10px;">
        <p>{{ picked_city.name }}</p>
        <a @click="removePickedCity(picked_city)" class="button is-danger">הסר</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'outsource-drushim-cities',
  props: ['picked_cities'],
  data () {
    return {
      is_choosing_city: false,
      search_results: [],
      search_term: ''
    }
  },
  methods: {
    searchCity (search_term) {
      this.$network_utils.caller.request('get', '/outsource_data/search_drushim_city', 'admin_headers', { search_term }).then(response => {
        this.search_results = Array.isArray(response) ? response : []
      }).catch(() => {
        // Jira b270b72c: a failed search used to leave an empty list with no explanation.
        this.search_results = []
        this.$utils.emit('show_toast', { text: 'החיבור לדרושים נכשל, נסי שוב בעוד רגע' })
      })
    },
    chooseCity (picked_city) {
      if (this.picked_cities.filter(city => city.id == picked_city.id)[0] != undefined) {
        return
      }
      if (this.picked_cities.length >= 9) {
        this.$utils.emit('show_toast', { text: 'עד עיר מגורים אחד' })
        return
      }
      this.search_results = []
      this.search_term = ''
      this.picked_cities.push(picked_city)
      this.$emit('input', this.picked_cities)
    },
    removePickedCity (city_to_remove) {
      let picked_cities = this.picked_cities.filter(picked_city => picked_city.id != city_to_remove.id)
      this.$emit('input', picked_cities)
    }
  }
}
</script>
<style scoped>
  .loading_container{
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
  }
  .loading_opacity{
    opacity: 0.6;
    position: absolute;
    background-color: white;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
  }
</style>
